import styled from 'styled-components';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }

  .containerButton {
    display: flex;
    justify-content: flex-end;
  }
`;

export const ContainerDropdown = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: space-between;
  
  @media (max-width: 850px) {
    flex-direction: column;
  }
`;

export const ContentDropdown = styled.div`
  flex: 1;
  min-width: 15rem;

  select {
    background: transparent;
    border: 1px solid ${({ theme }) => theme.colors.background_white};
    color: ${({ theme }) => theme.colors.background_white};
    padding: 0.75rem;
    border-radius: 0.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    width: 100%;
    appearance: none;
    background-image: url('data:image/svg+xml;utf8,<svg fill="white" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 1rem;

    option {
      color: ${({ theme }) => theme.colors.primary};
    }

    &:focus {
      outline: none;
      border-color: ${({ theme }) => theme.colors.secondary};
    }

    &:disabled {
      opacity: 0.5;
    }
  }
`;

export const GridCollaborators = styled.div`
  display: grid;
  gap: 1rem;
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const FindLawyerSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2rem; 
  background: ${({ theme }) => theme.colors.primary}; 

  h2 {
    font-size: 2.5rem; 
    font-weight: 700;
    color: ${({ theme }) => theme.colors.background_white};
    text-align: center;
    margin-bottom: 3rem; 
  }
`;

export const FindCorrespondentContainer = styled.div`
  background: rgba(255, 255, 255, 0.05); 
  border: 1px solid ${({ theme }) => theme.colors.background_white};
  border-radius: 1.5rem; 
  padding: 3rem; 
  width: 90%; 
  margin: 0 auto;

  h1 {
    font-size: 1.5rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.background_white};
    margin: 0.5rem 0;
  }

  @media (max-width: 850px) {
    width: 100%;
    padding: 2rem;
  }
`;
